module.exports = "/_next/static/images/ck-420c555e0bacbc73803f64f56df0dd33.svg";